import React, { useState } from 'react'

import Dialog from 'components/Dialog'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './MethodologySubTitle.module.scss'

const MethodologySubTitle = () => {
  const [isOpen, setOpen] = useState(false)
  const { addEvent } = useEventContext()
  const { sendEvent } = useEventContext({
    name: 'engagement_facet_click',
    engagementComponent: 'key-features-summary',
    engagementDestination: 'modal_reviews-methodology',
  })
  const handleOpen = () => {
    setOpen(true)
    sendEvent({
      engagementDetails: 'open_text-link_learn-more-about-our-reviews',
    })
  }

  const handleClose = () => {
    setOpen(false)
    sendEvent({
      engagementDetails: 'close_text-link_learn-more-about-our-reviews',
    })
  }

  return (
    <div>
      <Typography className={classes.description} data-testid="methodology-text">
        Based on{' '}
        <Link
          href="/resources/software-research-methodology/"
          target="_blank"
          className={classes.link}
          {...addEvent({
            name: 'engagement_facet_click',
            engagementComponent: 'key-features-summary',
            engagementDestination: 'go_to_blog_research_methodology',
            engagementDetails: 'getapps-analysis-link',
          })}
        >
          GetApp&apos;s analysis
        </Link>{' '}
        of verified user reviews collected between July 2021 and August 2024.{' '}
        <Link onClick={handleOpen} className={classes.descriptionLink}>
          Learn more about our reviews.
        </Link>
      </Typography>
      <Dialog title="Learn more about our reviews" onClose={handleClose} isOpen={isOpen} isSeoFriendly>
        <p>
          GetApp maintains a proprietary database of millions of in-depth, verified user reviews across thousands of
          products in hundreds of software categories. Our data scientists apply advanced modeling techniques to
          identify key insights about products based on those reviews. We may also share aggregated ratings and select
          excerpts from those reviews throughout our site.
        </p>
      </Dialog>
    </div>
  )
}

export default MethodologySubTitle
